import { CMS_QUERIES } from '@/constants/content-stack'

type QueriesGroup = (typeof CMS_QUERIES)[keyof typeof CMS_QUERIES]

const QUERIES_GROUP_LIST = Object.values(CMS_QUERIES) as QueriesGroup[]

const getQueryKey = (value: symbol) => {
  for (const group of QUERIES_GROUP_LIST) {
    for (const query of Object.values(group) as Array<
      Record<string, symbol> & { key: string }
    >) {
      if (Object.values(query).includes(value)) {
        return query.key
      }
    }
  }
  throw new Error(
    `CMS Query: Not able to find key related to symbol value ${value.toString()}`,
  )
}

/**
 * Transforms an array of queries (query symbols or falsy values)
 * into a Content Stack-compatible, removing the falsy values and
 * transforming the symbols into key-value pairs.
 *
 * See CMS_QUERIES constant at src/constants/content-stack.ts
 */
export function getQueryParams(query: Array<symbol | undefined | false>) {
  return (query.filter((value) => value) as symbol[]).map((value) => {
    if (!value.description) {
      throw new Error(
        'CMS Query: Symbol description is needed for building query params',
      )
    }
    return {
      key: getQueryKey(value),
      value: value.description,
    }
  })
}
